import {
  type OriginActionValueType,
  OriginView,
  type OriginViewValueType,
  type PanelNameValueType,
  takeActionPanelViewed,
} from '@/lib/analytics/Avo';

export const trackTakeActionPanelViewed = (
  panelName: PanelNameValueType,
  originView: OriginViewValueType | null | undefined,
  originAction: OriginActionValueType,
) => {
  takeActionPanelViewed({
    panelName,
    originView,
    originAction,
  });
};

// Helper to determine originView based on active tab in sheets
export const getSheetOriginView = (activeTab: string): OriginViewValueType | null => {
  switch (activeTab) {
    case 'all':
      return OriginView.BY_ALL_WORK_ITEMS;
    case 'byRiskType':
      return OriginView.BY_RISK_TYPE;
    case 'byFieldType':
      return OriginView.BY_MISSING_DATA;
    default:
      return null;
  }
};
